<template>
  <section id="assist__how">
    <h2>如何上课</h2>
    <div class="card">
      <div class="card__section" id="help-1">
        <div class="card__title">1. 完成助力</div>
        <div v-if="info.assist_status == 1">
          <div class="top">
            <div @click="stopAssist" class="card__btn btn-secondary">点击手动结束</div>
            <p>未满 {{ info.limit_time }} 人，放弃免费晋升合伙人的机会</p>
          </div>
          <div class="middle">
            <div class="line"></div>
            <span>或</span>
            <div class="line"></div>
          </div>
          <div class="bottom">
            <h1>
              <i class="anyteachicon anyteach-zhulihuodong" />
              累计 {{ info.limit_time }} 人助力
            </h1>
            <p>自动结束助力，晋升城市合伙人</p>
          </div>
        </div>
        <div v-else class="success">
          已完成
          <i class="anyteachicon anyteach-check-circle" />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__section" id="help-2">
        <div class="card__title">2. 联系小管家</div>
        <div class="guide">
          <div class="guide__item">
            <img :src="contact ? contact.qr_url : 'https://cdn.anyteach.cn/cs-2.jpeg'" />
            <span>长按加微信</span>
          </div>
          <div class="guide__item">
            <i class="anyteachicon anyteach-next" />
          </div>
          <div class="guide__item">
            <img src="https://cdn.anyteach.cn/img/assist/chat.jpg" />
            <span>“助力赢课时” + 手机号</span>
          </div>
        </div>
        <div class="card__bottom">
          <div
            class="copy btn-primary card__btn"
            :data-clipboard-text="'助力赢课时 ' + $store.state.user.mobile"
          >复制手机号</div>
          <p>点击复制发送给小管家的文字内容</p>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__section" id="help-3">
        <div class="card__title">3. 开始上课</div>
        <div class="card__text">
          小管家将在完成助力的第 3 天为您开课，
          <br />如：周一完成助力，周三开课。
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clipboard from "clipboard"
export default {
  name: "AssistHow",
  props: ["info", "remaining"],
  data() {
    return {
      contact: null,
    }
  },
  methods: {
    async getContact() {
      this.contact = await this.$api.user.CONTACT()
    },
    clipboard() {
      const clipboard = new Clipboard(".copy")
      clipboard.on("success", e => {
        this.$toastSuccess("复制成功，请发给小管家微信")
      })
      clipboard.on("error", e => {
        this.$toastError("复制失败，请手动输入")
      })
    },
    async stopAssist() {
      const confirm = window.confirm(`还差 ${this.remaining} 次助力即可晋升合伙人，确认提前结束？`)
      if (!confirm) {
        return
      }
      const res = await this.$api.assist.STOP(this.info.id)
      this.$emit("stop")
      return res
        ? this.$toastSuccess("成功完成助力活动")
        : this.$toastError("无法手动结束，请稍后重试")
    },
  },
  mounted() {
    this.getContact()
    this.clipboard()
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__how {
}

.card__btn {
  width: 110px;
  height: 35px;
  line-height: 35px;
  font-size: 0.9rem;
}

#help-1 {
  p {
    @include body();
    margin-top: 5px;
    font-size: 0.75rem;
  }
  .success {
    font-size: 1rem;
    @include avenir-demi();
    i {
      font-size: inherit;
      font-weight: 400;
    }
  }

  .top {
  }

  .middle {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 15px 0;
    .line {
      width: 80px;
      height: 1px;
      background: black;
      opacity: 0.15;
    }
    span {
      opacity: 0.6;
      font-size: 0.9rem;
    }
  }

  .bottom {
    h1 {
      font-size: 0.9rem;
      @include avenir-demi();
      margin: 0;
      i {
        font-weight: 400;
        font-size: inherit;
      }
    }
  }
}

#help-2 {
  .guide {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 15px 20px;
    span {
      display: block;
      font-size: 0.75rem;
      opacity: 0.6;
    }
  }
  .guide__item:first-child {
    img {
      width: 80px;
    }
  }
  .guide__item:nth-child(2) {
    i {
      font-size: 20px;
    }
  }
  .guide__item:last-child {
    img {
      width: 110px;
      border-radius: 4px;
      border: 1px solid #b3b3b3;
    }
  }
  .card__bottom {
    p {
      @include body();
      margin-top: 5px;
      font-size: 0.75rem;
    }
  }
}

#help-3 {
  .card__text {
    font-size: 0.9rem;
    @include avenir();
  }
}
</style>
